export const divStyle = {
  marginRight: 32,
  marginBottom: 32,
  float: 'left',
  position: 'relative',
  zIndex: 0,
}

export const icon= {
  color: '#FEFEFE',
  marginRight: 10,
}



/** WEBPACK FOOTER **
 ** ./src/components/AvatarCard/style.js
 **/